import Royal from "../../../../src/components/RenderImgs/royalcaninImgs";
import * as React from 'react';
export default {
  Royal,
  React
};